import type { ReactNode } from 'react';
import { PublicBrandProvider, type PublicBranding } from '../shell';
import styles from './listing.module.css';
import applyStyles from './apply/apply.module.css';

/** The scroll viewport every public page sits in, scoped to the business's brand (never to `<html>`). */
export function PublicRentalPage({ branding, children, kind = 'listing' }: { branding: PublicBranding; children: ReactNode; kind?: 'listing' | 'apply' }) {
  return (
    <PublicBrandProvider branding={branding} className={kind === 'apply' ? applyStyles.viewport : styles.viewport}>
      {children}
    </PublicBrandProvider>
  );
}
